module.exports = __webpack_public_path__ + "img/logo.839c7ee2.png";